<template>
  <div class="page-cont">
    <h1 class="page-title">修改密码</h1>

    <!-- 密码修改表单 -->
    <div class="form-container" style="width: 500px; margin: 0 auto; padding: 20px; border: 1px solid #e6e6e6; border-radius: 4px; background-color: #fafafa;">
      <!-- 错误提示 -->
      <div v-if="errorMsg" style="color: #f56c6c; margin-bottom: 15px; padding: 10px; border: 1px solid #fce4e4; border-radius: 4px;">
        <i class="el-icon-error"></i> {{ errorMsg }}
      </div>

      <!-- 表单 -->
      <el-form
        :model="passwordForm"
        :rules="formRules"
        ref="passwordFormRef"
        label-width="100px"
        style="margin-top: 20px;"
      >
        <!-- 旧密码 -->
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入旧密码"
            clearable
            @input="clearError"
          />
        </el-form-item>

        <!-- 新密码 -->
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            clearable
            @input="clearError"
          />
        </el-form-item>

        <!-- 确认新密码 -->
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            clearable
            @input="clearError"
          />
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item style="text-align: center;">
          <el-button
            type="primary"
            @click="submitChangePassword"
            :loading="loading"
            size="medium"
            style="width: 200px;"
          >
            确认修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ChangepasswordPage",
  data() {
    // 自定义校验规则：两次密码一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      // 表单数据
      passwordForm: {
        oldPassword: '', // 旧密码
        newPassword: '', // 新密码
        confirmPassword: '' // 确认新密码
      },
      // 表单校验规则
      formRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false, // 提交加载状态
      errorMsg: '' // 错误提示信息
    };
  },
  mounted() {
    // 检查是否有用户邮箱（无则提示并跳转）
    const userEmail = localStorage.getItem("UserEmail");
    if (!userEmail) {
      this.errorMsg = '未检测到用户信息，请先登录';
      this.$router.push('/login');
    }
  },
  methods: {
    /**
     * 清空错误提示
     */
    clearError() {
      this.errorMsg = '';
    },

    /**
     * 提交密码修改请求
     */
    async submitChangePassword() {
      try {
        // 1. 表单前置校验
        await this.$refs.passwordFormRef.validate();

        // 2. 基础数据校验
        const userEmail = localStorage.getItem("UserEmail");
        const token = localStorage.getItem('token');
        
        // 校验用户邮箱
        if (!userEmail) {
          this.errorMsg = '未检测到用户信息，请重新登录';
          this.$router.push('/login');
          return;
        }

        // 校验Token
        if (!token) {
          this.errorMsg = '未检测到登录凭证，请重新登录';
          this.$router.push('/login');
          return;
        }

        this.loading = true;
        this.errorMsg = '';

        // 3. 构建请求参数
        const requestData = {
          oldPassword: this.passwordForm.oldPassword, // 旧密码
          newPassword: this.passwordForm.newPassword // 新密码
        };

        // 4. 调用修改密码接口
        const res = await axios.post(
          `${this.$store.state.ServerAddress}/api/admin/change-password`,
          requestData,
          {
            headers: {
              authorization: `Bearer ${token}`, // Token认证
              'Content-Type': 'application/json'
            }
          }
        );

        // 5. 处理响应
        if (res.data.success) {
          this.$message.success('密码修改成功！请重新登录');
          // 清空密码表单
          this.passwordForm.oldPassword = '';
          this.passwordForm.newPassword = '';
          this.passwordForm.confirmPassword = '';
          // 清空本地存储（强制重新登录）
          localStorage.removeItem('token');
          localStorage.removeItem('UserEmail');
          // 跳转登录页
          setTimeout(() => {
            this.$router.push('/login');
          }, 1500);
        } else {
          this.errorMsg = res.data.messages || '密码修改失败，请重试';
          this.$message.error(this.errorMsg);
        }
      } catch (error) {
        console.error('修改密码失败：', error);
        // 表单校验失败不处理（已由el-form提示）
        if (error.name !== 'ValidationError') {
          // Token过期处理
          if (error.response?.status === 401) {
            this.errorMsg = '登录凭证已过期，请重新登录';
            localStorage.removeItem('token');
            localStorage.removeItem('UserEmail');
            this.$router.push('/login');
          } else if (error.response?.status === 400) {
            // 后端返回的业务错误
            this.errorMsg = error.response.data.messages || '表单不合法';
          } else if (error.response?.status === 500) {
            this.errorMsg = '服务器内部错误，请稍后重试';
          } else {
            this.errorMsg = '网络异常，修改失败';
          }
          this.$message.error(this.errorMsg);
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.page-cont {
  margin-left: 10px;
  padding: 10px;
  min-width: 85vw;
  background-color: white;
  min-height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-title {
  color: black;
  margin-top: 20px;
  margin-bottom: 30px;
  align-self: flex-start;
  margin-left: calc((100% - 500px)/2);
}

.form-container {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>